import { render } from "./WCPwaPromotionToast.vue?vue&type=template&id=47cdf754&scoped=true"
import script from "./WCPwaPromotionToast.vue?vue&type=script&lang=js"
export * from "./WCPwaPromotionToast.vue?vue&type=script&lang=js"

import "./WCPwaPromotionToast.vue?vue&type=style&index=0&id=47cdf754&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47cdf754"]])

export default __exports__